import AntdAvatar from 'components/Avatar'
import Button from 'components/Button/index'
import Drawer from 'components/Drawer'
import Flex from 'components/Flex'
import ClockOrange from 'components/icons/ClockOrange'
import LeftMarkIcon from 'components/icons/LeftMarkIcon'
import RightArrowIcon from 'components/icons/RightArrowIcon'
import {
  AdjustIcon,
  BreakText,
  BreakWrapper,
  CaroselDiv,
  CarouselFlex,
  FooterFlex,
  GroupFlex,
  GroupIdDiv,
  HeaderFlex,
  IntervierFlex,
  InterviewFlex,
  InterviewInfoFlex,
  RightArrowDiv,
  Sliders,
  TagWarapper,
  TimeDiv,
  TimeFlex,
} from 'modules/Exp-Candidates/ViewDriveRole/BulkActionDrawer/CreateSlotDrawer/ManyToManyPreview/style'
import moment from 'moment'
import React, { useEffect, useRef, useState } from 'react'
import { getIdFormate } from 'utils/getZeroBeforeInt'

const PreviewAndSchedule = ({
  schedulePreview,
  setSchedulePreview,
  setCreateSlotDrawer,
  confirmedResponse,
  interviewType,
  setPrivew,
}) => {
  const [slide, setSlide] = useState(0)
  const [currentPanel, setCurrentPanel] = useState(0)
  const [breakList, setBreakList] = useState([])

  const [groupList, setGroupList] = useState([])
  const [faceToFaceList, setFaceToFaceList] = useState([])

  useEffect(() => {
    const removeLastItem = (list, conditionFn) => {
      while (list?.length > 0 && conditionFn(list[list.length - 1])) {
        list.pop()
      }
    }
    if (interviewType === 'GROUP') {
      let confirmList = confirmedResponse?.result[currentPanel]?.groups || []
      let list = [...confirmList]
      let updatedList = list?.sort(
        (data1, data2) => moment(data1?.startTime) - moment(data2?.startTime)
      )

      const conditionFnGroup = item => item?.type

      removeLastItem(updatedList, conditionFnGroup)
      setGroupList(updatedList)
    } else {
      let confirmList = confirmedResponse?.result[currentPanel]?.candidate || []

      let list = [...confirmList, ...(breakList || [])]
      let updatedList = list?.sort(
        (data1, data2) =>
          moment(data1?.schedualedTime?.start || data1?.startTime) -
          moment(data2?.schedualedTime?.start || data2?.startTime)
      )
      const conditionFnOther = item => item?.type
      removeLastItem(updatedList, conditionFnOther)
      setFaceToFaceList(updatedList)
    }
  }, [breakList, confirmedResponse, currentPanel])

  useEffect(() => {
    const updatedList = confirmedResponse?.breaks?.filter(
      (breaks, index, array) =>
        array?.findIndex(
          data =>
            data?.type === breaks?.type &&
            data?.startTime === breaks?.startTime &&
            data?.endTime === breaks?.endTime
        ) === index
    )
    setBreakList(updatedList)
  }, [confirmedResponse])

  const handleConfirm = () => {
    setPrivew(true)
    setCreateSlotDrawer(false)
  }

  const handleBack = () => {
    setCreateSlotDrawer(true)
    setSchedulePreview(false)
  }

  const slider = useRef()

  const content = () => {
    return (
      <div>
        <HeaderFlex row centerVertically>
          <AdjustIcon
            onClick={() => {
              slider.current.prev()
            }}
          >
            <LeftMarkIcon />
          </AdjustIcon>
          <CaroselDiv>
            <Sliders
              dots={false}
              ref={ref => {
                slider.current = ref
              }}
              beforeChange={() => setSlide(true)}
              afterChange={data => {
                setCurrentPanel(data)
                setSlide(false)
              }}
            >
              {confirmedResponse?.linkAndPanel?.map((panel, index) => {
                return (
                  <div key={index + 'linkAndPanel'}>
                    <CarouselFlex row>
                      <IntervierFlex centerVertically value={slide}>
                        Panel{index + 1}-&nbsp;
                        {panel?.panel?.slice(0, 1)?.map((item, kIndex) => {
                          return (
                            <TagWarapper key={kIndex + item?.firstName}>
                              {item?.firstName + ' ' + item?.lastName}
                            </TagWarapper>
                          )
                        })}
                        {!!(panel?.panel?.length - 1) && (
                          <TagWarapper>+{panel?.panel?.length - 1}</TagWarapper>
                        )}
                      </IntervierFlex>
                      {confirmedResponse?.linkAndPanel[index + 1] && (
                        <IntervierFlex centerVertically value={slide}>
                          Panel{index + 2}-&nbsp;
                          {confirmedResponse?.linkAndPanel[index + 1]?.panel
                            ?.slice(0, 1)
                            ?.map(item => {
                              return (
                                <TagWarapper key={item?.firstName}>
                                  {item?.firstName + ' ' + item?.lastName}
                                </TagWarapper>
                              )
                            })}
                          {!!(panel?.panel?.length - 1) && (
                            <TagWarapper>
                              +{panel?.panel?.length - 1}
                            </TagWarapper>
                          )}
                        </IntervierFlex>
                      )}
                    </CarouselFlex>
                  </div>
                )
              })}
            </Sliders>
          </CaroselDiv>
          <RightArrowDiv
            onClick={() => {
              slider.current.next()
            }}
          >
            <RightArrowIcon />
          </RightArrowDiv>
        </HeaderFlex>
        {interviewType === 'GROUP' &&
          groupList?.map((data, index) =>
            data?.groupId ? (
              <GroupFlex key={index + 'interviewType'} row centerVertically>
                <TimeFlex column>
                  <TimeDiv font="12px">
                    {moment(data?.startTime).format('hh:mm A')}
                  </TimeDiv>
                  <TimeDiv font="12px">
                    {moment(data?.startTime).format('DD-MM-YYYY')}
                  </TimeDiv>
                </TimeFlex>
                <InterviewInfoFlex row>
                  <InterviewFlex column>
                    <InterviewFlex centerVertically spaceBetween>
                      <div>
                        <GroupIdDiv>{getIdFormate(data.groupId)}</GroupIdDiv>
                        <TimeDiv font="10px">
                          {moment(data?.startTime).format('hh:mm A')} -{' '}
                          {moment(data?.endTime).format('hh:mm A')}
                        </TimeDiv>
                      </div>
                    </InterviewFlex>
                    <Flex row>
                      {data?.candidates?.map((item, index) => {
                        return (
                          <AntdAvatar
                            size="30px"
                            padding="8px"
                            IconName={item?.firstName?.charAt(0)}
                            key={index + item?.firstName}
                          />
                        )
                      })}
                    </Flex>
                  </InterviewFlex>
                </InterviewInfoFlex>
              </GroupFlex>
            ) : (
              <BreakWrapper center alignCenter key={index + data?.type}>
                <ClockOrange />
                <BreakText>
                  {data?.type} - {moment(data?.startTime).format('hh:mm A')} -{' '}
                  {moment(data?.endTime).format('hh:mm A')}
                </BreakText>
              </BreakWrapper>
            )
          )}

        {interviewType === 'FACE_TO_FACE' &&
          faceToFaceList?.map((item, index) =>
            item?.studentId ? (
              <GroupFlex key={index + 'faceTo_Face'} row centerVertically>
                <TimeFlex column>
                  <TimeDiv font="12px">
                    {moment(item?.schedualedTime?.start).format('hh:mm A')}
                  </TimeDiv>
                  <TimeDiv font="12px">
                    {moment(item?.schedualedTime?.start).format('DD-MM-YYYY')}
                  </TimeDiv>
                </TimeFlex>
                <InterviewInfoFlex row>
                  <InterviewFlex row>
                    <Flex row>
                      <AntdAvatar
                        size="30px"
                        padding="8px"
                        IconName={item?.firstName?.charAt(0)}
                      />
                    </Flex>
                    <InterviewFlex centerVertically spaceBetween>
                      <div>
                        <GroupIdDiv>
                          {item?.firstName} {item?.lastName}
                        </GroupIdDiv>
                        <TimeDiv font="10px">
                          {moment(item?.schedualedTime?.start).format(
                            'hh:mm A'
                          )}{' '}
                          -{' '}
                          {moment(item?.schedualedTime?.end).format('hh:mm A')}
                        </TimeDiv>
                      </div>
                    </InterviewFlex>
                  </InterviewFlex>
                </InterviewInfoFlex>
              </GroupFlex>
            ) : (
              <BreakWrapper center alignCenter key={index + item?.type}>
                <ClockOrange />
                <BreakText>
                  {item?.type} - {moment(item?.startTime).format('hh:mm A')} -{' '}
                  {moment(item?.endTime).format('hh:mm A')}
                </BreakText>
              </BreakWrapper>
            )
          )}
      </div>
    )
  }

  const footer = () => {
    return (
      <FooterFlex flexEnd>
        <Button.Secondary
          width="88px"
          height="38px"
          text="Back"
          onClick={handleBack}
        />
        <Button.Primary
          width="95px"
          height="38px"
          text="Proceed"
          onClick={handleConfirm}
        />
      </FooterFlex>
    )
  }
  return (
    <Drawer
      width="43%"
      title={'Schedule - Preview'}
      placement="right"
      visible={schedulePreview}
      content={content()}
      footer={footer()}
      onClose={setSchedulePreview(false)}
      closable
    />
  )
}

export default PreviewAndSchedule
